import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { AttachmentGetCollectionByStageId, AttachmentGetCollectionByStageIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<AttachmentGetCollectionByStageIdResponse, AttachmentGetCollectionByStageIdResponse>) => {
    return response?.data?.attachments
}
const getError = (response?: SWRResponse<AttachmentGetCollectionByStageIdResponse, AttachmentGetCollectionByStageIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetCollectionByStageIdResponse, StageGetCollectionByStageIdResponse>) => ({});

const useAttachmentsByStageId = (stageId: number, configuration?: SWRConfiguration<AttachmentGetCollectionByStageIdResponse, AttachmentGetCollectionByStageIdResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new AttachmentGetCollectionByStageId({
                stageId: stageId
            });
        };
    }, [stageId])

    return useGet(request, { getData, getError }, configuration);
}

export default useAttachmentsByStageId;